<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.posbranchmanagement') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="ready"
            class="action">
            <div
              v-if="hasRoleDelete"
              class="dropdown item"
            >
              <button
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  class="dropdown-item"
                  @click="onOpenModal">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-else>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.general')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label>{{ $t('message.posbranchname') }} *</label>
                    <input
                      v-model="$v.form.name.$model"
                      :class="['form-control', { 'is-invalid': $v.form.name.$error }]"
                      :disabled="!hasRoleEdit"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-6">
                    <label>
                      {{ $t('message.posbranchnameshort') }} *
                      <vs-tooltip
                        :text="$t('message.runningcodenumber')"
                        position="top"
                        style="float: right;margin-left: 5px;">
                        <i class="fas fa-info-circle"/>
                      </vs-tooltip>
                    </label>
                    <input
                      v-model="$v.form.nameShort.$model"
                      :placeholder="$t('placeholder.maximumlength6char')"
                      :maxlength="6"
                      :class="['form-control text-uppercase', { 'is-invalid': $v.form.nameShort.$error }]"
                      :disabled="!hasRoleEdit"
                    >
                  </div>
                  <div
                    v-if="nameShortUppercase"
                    class="col-6 pl-0">
                    <label>&nbsp;</label>
                    <div class="preview-short-name">
                      <span
                        v-html="$t('message.previewpscode', {
                          name: nameShortUppercase,
                          code: `${moment().format('YYYY/MM/DD')}/01`,
                        })"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.location')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label>{{ $t('message.address') }}</label>
                    <b-form-textarea
                      v-model="form.address"
                      :disabled="!hasRoleEdit"
                      style="min-height: 70px;"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.config')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label>
                      {{ $t('message.posbranchcountingstrock') }}
                      <vs-tooltip
                        :text="$t('message.cutstockfromselectedwarehouse')"
                        position="top"
                        style="float: right;margin-left: 5px;">
                        <i class="fas fa-info-circle"/>
                      </vs-tooltip>
                    </label>
                    <select
                      v-model="form.whId"
                      :disabled="!hasRoleEdit"
                      class="form-control custom-select"
                    >
                      <option :value="null">
                        {{ $t('placeholder.select') }}
                      </option>
                      <option
                        v-for="(item, index) in form.whItems"
                        :index="index"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignproducts')"/>
            <BaseNotFoundData
              v-if="!products.length"
              :title="$t('apps.pos.message.notfoundproduct')"
              :detail="$t('apps.pos.message.createproduct')"
            />
            <base-assign-items
              v-else
              v-model="form.assignProductIds"
              :items="form.assignProductItems"
              :disabled="!hasRoleEdit"
            />
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.favoriteproducts')"/>
            <base-assign-items
              v-model="form.favoriteProductIds"
              :items="form.favoriteProductItems"
              :disabled="!hasRoleEdit"
            />
          </div>
        </section>

        <section
          v-if="hasRoleEdit"
          class="action-bar"
        >
          <div
            v-if="!isSubmitted"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" @click="onCancel">{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              @click="onSave">{{ $t('button.save') }}</button>
          </div>
          <div
            v-else
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <base-confirm-delete-modal
      :show="showConfirmDeleteModal"
      :loading="loadingModal"
      @onClose="handleCloseModal"
      @onCancel="handleCancleModal"
      @onSubmit="handleSumitModal"
    />

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,
      isSubmitted: false,
      form: {
        name: null,
        nameShort: null,
        address: null,
        whId: null,
        whItems: [],
        assignProductIds: [],
        assignProductItems: [],
        favoriteProductIds: [],
        favoriteProductItems: [],
      },
      formOriginal: null,
      showConfirmDeleteModal: false,
      loadingModal: false,
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      nameShort: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
    }),
    nameShortUppercase () {
      return this.form.nameShort
        ? this.form.nameShort.trim().toUpperCase()
        : null
    },
    branch () {
      return this.$store.state.posBranch.branch
    },
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 3, [{
      'name': this.$route.query.name,
      'router': {
        'name': 'PosBranchEdit',
        'query': {
          id: this.$route.query.id,
          name: this.$route.query.name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 3,
      submenuAtIdx: 2,
    })
  },
  async created () {
    await this.fetchData()
    this.setState()
    this.formOriginal = _.cloneDeep(this.form)
  },
  destroyed () {
    this.leavePage(this.$Progress)
  },
  methods: {
    async fetchData () {
      this.ready = false
      await Promise.all([
        this.getPosBranch(),
        this.getProducts(),
        this.getWarehouses(),
      ])
      this.ready = true
      this.showFinish(this.$Progress)
    },
    async getPosBranch () {
      await this.$store.dispatch('getPosBranch', {
        id: this.$route.query.id,
        params: {},
      })
      const notfound = !this.branch.branchId
      if (notfound) {
        this.$router.push({ name: 'PosBranchAll' })
      }
    },
    async getProducts () {
      this.form.assignProductItems = []
      this.form.favoriteProductItems = []
      await this.$store.dispatch('getProducts')
      for (const product of this.products) {
        const item = {
          text: product.product_name,
          value: product.product_id,
        }
        this.form.assignProductItems.push(item)
        this.form.favoriteProductItems.push(item)
      }
    },
    async getWarehouses () {
      this.form.whItems = []
      await this.$store.dispatch('getWarehouses')
      for (const warehouse of this.warehouses) {
        const item = {
          text: warehouse.warehouse_name,
          value: warehouse.warehouse_id,
        }
        this.form.whItems.push(item)
      }
    },
    onCancel () {
      this.ready = false
      this.form = _.cloneDeep(this.formOriginal)
      setTimeout(() => this.ready = true, 1000)
    },
    async onSave () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return this.scrollToTop(600)
      }
      this.isSubmitted = true

      const [response, , ] = await Promise.all([
        await this.$store.dispatch('updatePosBranch', {
          id: this.$route.query.id,
          params: {
            'name': this.form.name,
            'name_short': this.form.nameShort.toUpperCase().trim(),
            'address': this.form.address,
            'wh_id': this.form.whId,
          },
        }),
        this.$store.dispatch('updatePosBranchAssignProductIds', {
          id: this.$route.query.id,
          params: {
            'product_ids': this.form.assignProductIds,
          },
        }),
        this.$store.dispatch('updatePosBranchFavoriteProductIds', {
          id: this.$route.query.id,
          params: {
            'product_ids': this.form.favoriteProductIds,
          },
        }),
      ])
      if (response.success) {
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    setState () {
      this.form.name = this.branch.name
      this.form.nameShort = this.branch.nameShort
      this.form.address = this.branch.address
      this.form.whId = this.branch.whId
      this.form.assignProductIds = this.branch.assignProducts.map((item) => item.productId)
      this.form.favoriteProductIds = this.branch.favoriteProducts.map((item) => item.productId)
    },
    onOpenModal () {
      this.showConfirmDeleteModal = true
    },
    handleCloseModal () {
      this.showConfirmDeleteModal = false
    },
    handleCancleModal () {
      this.showConfirmDeleteModal = false
    },
    async handleSumitModal () {
      this.loadingModal = true
      const response = await this.$store.dispatch('deletePosBranch', this.$route.query.id)
      this.notify(this.$vs, {
        text: this.$t('message.hasbeendeleted', { msg: this.form.name }),
        color: 'danger',
        icon: 'delete',
      })
      this.showConfirmDeleteModal = false
      this.$router.push({ name: 'PosBranchAll' })
    },
  },
}
</script>

<style scoped>
.preview-short-name {
  display: flex;
  align-items: center;
  width: 100%;
  height: 35px;
  border: solid 1px #ced4da;
  border-radius: 4px;
  color: #495057;
  background: #e9ecef;
  padding: .375rem .75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/branch/Edit.vue